import { StatusBar, StyleSheet } from "react-native";

const styles = StyleSheet.create({
    mainContainer: {
        flex: 1,
        paddingTop: StatusBar.currentHeight,
        backgroundColor: "#fff",
        alignItems: 'center'
    },
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 30,
        width: "70%",
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: 30
    },
    headerLogo: {
        width: 74,
        height: 100
    },
    headerTitle: {
        fontFamily: 'Montserrat_400Regular',
        fontSize: 30,
        marginLeft: 20,
        width: "80%"
    },
    items: {
        width: '80%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 70,
        marginBottom: 30
    },
    itemContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: 20
    },
    itemText: {
        fontSize: 24,
        width: '70%',
        fontFamily: 'Montserrat_400Regular'
    },
    itemButton: {
        alignItems: 'center',
        justifyContent: 'center',
        width: 75,
        height: 75,
        borderRadius: 20,
        backgroundColor: "#ccc"
    }
});

export default styles;